import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
import { useFormField } from "../../components/base/form";
const FormErrorMessage = React.forwardRef(({ className, message, ...props }, ref) => {
    const { error, formMessageId } = useFormField();
    if (!error) {
        return null;
    }
    return (_jsx("p", { ref: ref, id: formMessageId, className: cn("text-sm font-medium text-red-500 dark:text-red-900", className), ...props, children: message }));
});
FormErrorMessage.displayName = "FormErrorMessage";
export { FormErrorMessage };
//# sourceMappingURL=form-plus.js.map